import {IResource, IResourceGroup} from "@retail-data-factory/rdf-angular-types-api";

export interface IResourcesState {
//  data: Array<IResource>;
  data: {
    resources: Array<IResource>;
    resourceGroups: Array<IResourceGroup>;
  };
  isLoaded: boolean;

}
export const initialResourcesState:IResourcesState = {
  //data: [],
  data: {
    resources:[],
    resourceGroups:[]
  },
  isLoaded: false
};

export interface IResourceGroupsState {
  data: Array<IResourceGroup>;
  isLoaded: boolean;
}

export const initialResourceGroupsState:IResourceGroupsState = {
  data: [],
  isLoaded: false
};

